// == Import npm
import React, { useState } from "react";
import { Input, Empty, message } from "antd";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  searchVisitor,
  searchResident,
  updateVisitsFromUser,
  createVisitForBadgeLost,
  updateCurrentResident,
} from "services/features/VisitsSlice";
import debounce from "lodash.debounce";
import classNames from "classnames";
import { isEmpty } from "ramda";

// == Import SCSS
import "./searchBar.less";

// == Import assets

// == import components
import Loader from "./Loader/Loader";

// == import i18n
import { useTranslation } from "react-i18next";

const { Search } = Input;

const SearchBar = ({ searchResult, type, searchText, setDisplay, badgeLost }) => {
  const history = useHistory();

  const [isDisplay, setIsDisplay] = useState(false);
  const [isDisplayCaract, setIsDisplayCaract] = useState(false);
  const [loader, setLoader] = useState(false);
  const [loaderSearch, setLoaderSearch] = useState(false);

  const searchUser = (text, type) => {
    if (type === "resident") return searchResident(text);
    else return searchVisitor(text);
  };

  const [t] = useTranslation();

  const dispatch = useDispatch();

  const handleSearch = async evt => {
    if (evt.target.value.length > 0) {
      setIsDisplay(true);
    }
    if (evt.target.value.length > 0 && evt.target.value.length < 3) {
      setIsDisplayCaract(true);
      dispatch(searchUser("", type));
    }
    if (evt.target.value.length >= 3) {
      setLoaderSearch(true);
      try {
        await dispatch(searchUser(evt.target.value, type));
      } finally {
        setLoaderSearch(false);
      }
      setIsDisplay(true);
      setIsDisplayCaract(false);
    } else if (evt.target.value.length === 0) {
      setIsDisplay(false);
      dispatch(searchUser("", type));
    }
  };

  const handleSearchDebounced = debounce(handleSearch, 500);

  const closeBubble = () => {
    setDisplay(false);
  };

  const selectUser = async selectedUser => {
    try {
      setLoader(true);
      const visits = await dispatch(updateVisitsFromUser(selectedUser));
      if (badgeLost) {
        const visit = await dispatch(createVisitForBadgeLost(selectedUser.id));
        history.push({
          pathname: `/meetingPage/${selectedUser.id}`,
          state: { type: "resident", printVisitBadgeLost: visit.id },
        });
      }
      // selected user is a resident
      else if (!selectedUser.isVisitor) {
        history.push({ pathname: `/meetingPage/${selectedUser.id}`, state: { type: "resident" } });
      }
      // selected user is a visitor
      else {
        if (visits.length) {
          dispatch(updateCurrentResident(visits[0].resident));
          history.push({ pathname: `/meetingPage/${selectedUser.id}`, state: { type: "visitor" } });
        } else {
          message.error(t("NoVisitToday"), 10);
          history.push({ pathname: `/searchByResident` });
        }
      }
    } finally {
      setLoader(false);
    }
  };

  const cssClassDisplay = classNames("searchBar__result", {
    "searchBar__result--display": isDisplay,
  });

  const cssClassDisplayNoResult = classNames("searchBar__noResult", {
    "searchBar__noResult--display": isDisplay,
  });

  const cssClassDisplayCaract = classNames("searchBar__noResult__text", {
    "searchBar__noResult__text--display": isDisplayCaract,
  });

  const cssClassDisplaytext = classNames("searchBar__noResult__text", {
    "searchBar__noResult__text--display": !isDisplayCaract,
  });

  return (
    <section className="searchBar">
      {loader && <Loader />}
      <Search
        style={{ zIndex: 9, width: "700px" }}
        placeholder={searchText}
        onChange={handleSearchDebounced}
        onClick={e => {
          e.stopPropagation();
          closeBubble();
        }}
      />
      {loaderSearch ? (
        <div className={cssClassDisplay}>
          {" "}
          <p className="searchBar__result__loader">{t("Loading")}</p>
        </div>
      ) : !isEmpty(searchResult) ? (
        <div className={cssClassDisplay}>
          {searchResult.map((result, index) =>
            result.isVisitor ? (
              <span
                className="searchBar__result__text"
                key={index}
                onClick={() => {
                  selectUser(result);
                }}
              >
                <span>
                  {result.lastname} {result.firstname}
                  {result.company ? ` (${result.company})` : ""}
                </span>
              </span>
            ) : (
              <span
                className="searchBar__result__text"
                key={index}
                onClick={() => {
                  selectUser(result);
                }}
              >
                {result.lastname} {result.firstname}{" "}
                {result.function ? ` (${result.function})` : ""}
              </span>
            ),
          )}
        </div>
      ) : (
        <div className={cssClassDisplayNoResult}>
          {type === "resident" ? (
            <>
              <p className={cssClassDisplayCaract} style={{ textAlign: "center" }}>
                {" "}
                {t("EnterLetters")} <br />
              </p>
              <Empty className={cssClassDisplaytext} description={t("NoResident")} />
            </>
          ) : (
            <>
              <p className={cssClassDisplayCaract} style={{ textAlign: "center" }}>
                {" "}
                {t("EnterLetters")} <br />
              </p>
              <Empty className={cssClassDisplaytext} description={t("NoVisitor")} />
            </>
          )}
        </div>
      )}
    </section>
  );
};

export default SearchBar;
